<template>
  <div class="row my-feedback">
    <div class="my-feedback-left">
      <div @click="onNewFeedbackClick" class="row filter-btn">
        新的反馈
      </div>
      <div class="my-feedback-list">
        <feedback-list @feedbackId="feedbackId" class="feedback-list" :data="item" v-for="item in feedbackList" :key="item.id"></feedback-list>
      </div>
      <div v-if="!feedbackList.length">
        <img class="empty-page-img" src="../assets/img/empty-page-list.svg" alt="">
        <div class="empty-page-word">还没有任何提交反馈内容</div>
      </div>
    </div>
    <div class="my-feedback-right">
      <div v-if="feedbackList.length" class="my-feedback-right-content">
        <div class="my-feedback-right-message">
          <div class="title">{{title}}</div>
          <div v-if="createTime" class="create-time">
            {{mobile}} 提交于 {{createTime}}
          </div>
          <div class="content">{{content}}</div>
        </div>
        <FeedbackSupplement :data="reply"></FeedbackSupplement>
      </div>
      <div v-if="feedbackList.length" class="feedback-textarea">
        <el-input @keypress.enter.native="onUpdateFeedback" resize="none" type="textarea" class="feedback-input" placeholder="问题反馈补充" v-model="questionFeedback"></el-input>
        <div @click="onUpdateFeedback" class="feedback-btn">更新反馈</div>
      </div>
      <div v-if="!feedbackList.length">
        <img class="empty-page-img" src="../assets/img/yanbaocool.svg">
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackList from '@/components/feedback/FeedbackList';
import FeedbackSupplement from '@/components/feedback/FeedbackSupplement';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      questionFeedback: '',
      id: -1,
      feedbackList: [],
      title: '',
      content: '',
      createTime: '',
      reply: [],
      timer: null,
      ele: null,
      mobile: ''
    };
  },
  methods: {
    getFeedbackList() {
      QuestionQuery.getFeedbackList().then(res => {
        res.pageItems.forEach((item, index) => {
          if (!index) {
            item.check = true;
          } else {
            item.check = false;
          }
        });
        this.feedbackList = res.pageItems;
        if (res.pageItems.length) {
          this.id = res.pageItems[0].id;
          this.getFeedbackReply();
        }
      }); 
    },
    getFeedbackReply() {
      QuestionQuery.getFeedbackReply(this.id).then(res => {
        this.title = res.title;
        this.content = res.content;
        this.createTime = res.create_time;
        this.mobile = res.mobile;
        this.reply = res.reply;
        if (this.ele) {
          this.ele.scrollTop = this.ele.scrollHeight;
        }
      });
    },
    feedbackId(id) {
      this.feedbackList.forEach((item) => {
        if (item.id === id) {
          item.check = true;
        } else {
          item.check = false;
        }
      });
      this.id = id;
      this.ele = document.querySelectorAll('.my-feedback-right-content')[0];
      this.getFeedbackReply();
    },
    onNewFeedbackClick() {
      eventBus.$emit('newFeedback');
    },
    onUpdateFeedback() {
      if (!this.questionFeedback) {
        this.$message({
          message: '请输入更新反馈内容',
          duration: 1500,
          type: 'error'
        });
      } else {
        QuestionQuery.postFeedbackReply(this.id, this.questionFeedback).then(() => {
          this.getFeedbackReply();
          this.questionFeedback = '';
        });
      }
    }
  },
  components: {
    FeedbackList,
    FeedbackSupplement
  },
  mounted() {
    this.ele = document.querySelectorAll('.my-feedback-right-content')[0];
    this.getFeedbackList();
    eventBus.$on('getFeedbackList', () => {
      this.getFeedbackList();
    });
    this.timer = window.setInterval(() => {
      if (this.id !== -1) {
        this.getFeedbackReply();
      }
    }, 1000 * 5);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
  }
};
</script>

<style lang="scss" scoped>
  .my-feedback {
    margin: 28px auto 0;
    width: 1200px;
    height: calc(100vh - 164px);
    .my-feedback-left {
      position: relative;
      padding: 24px;
      margin-right: 8px;
      width: 508px;
      height: 100%;
      background-color: #ffffff;
      .filter-btn {
        height: 32px;
        width: 108px;
        padding: 5px 16px;
        margin-right: 10px;
        margin-bottom: 24px;
        border-radius: 2px;
        color: #ffffff;
        background-color: #2b76ff;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        &:before {
          content: "";
          margin-right: 4px;
          margin-top: 3px;
          width: 16px;
          height: 16px;
          background: url("../assets/img/feedback-btn.svg") no-repeat;
          background-size: cover;
        }
      }
      .feedback-list {
        margin-bottom: 10px;
      }
      .my-feedback-list {
        height: calc(100vh - 268px);
        overflow: auto;
      }
      .empty-page-img {
        position: absolute;
        left: 50%;
        top: 224px;
        transform: translateX(-50%);
      }
      .empty-page-word {
        position: absolute;
        left: 50%;
        top: 409px;
        transform: translateX(-50%);
        font-size: 14px;
        font-weight: 500;
        color: #747990;
      }
    }
    .my-feedback-right {
      position: relative;
      padding: 32px;
      width: 684px;
      height: 100%;
      background-color: #ffffff;
      .my-feedback-right-content {
        height: calc(100vh - 345px);
        overflow: auto;
        .my-feedback-right-message {
          padding-bottom: 16px;
          box-shadow: inset 0px -1px 0px 0px #f2f3f7;
          .title {
            margin-bottom: 16px;
            color: #171f46;
            font-size: 16px;
            font-weight: 500;
          }
          .create-time {
            margin-bottom: 16px;
            color: #747990;
            font-size: 12px;
            font-weight: 500;
          }
          .content {
            color: #747990;
            font-size: 14px;
          }
        }
      }
      .feedback-textarea {
        position: relative;
        .feedback-btn {
          position: absolute;
          bottom: 12px;
          right: 12px;
          height: 32px;
          width: 88px;
          padding: 5px 16px;
          border-radius: 2px;
          color: #ffffff;
          background-color: #2b76ff;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .empty-page-img {
        position: absolute;
        left: 50%;
        top: 327px;
        transform: translateX(-50%);
      }
    }
  }
  /deep/.el-textarea .el-textarea__inner {
      height: 117px;
      padding-right: 99px;
      border-radius: 2px;
      border: solid 1px #e5e6ee;
      font-weight: 500;
      &::-webkit-input-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &::-moz-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &::-ms-input-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &:hover {
        border-radius: 2px;
        border: solid 1px #999ebe;
      }
      &:focus {
        border-radius: 2px;
        border: solid 1px #171f46;
      }
    }
</style>
